module.exports = __webpack_public_path__ + "img/logo_blank.0494b0b2.svg";